<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.01 10-.96-.95L8.4 5.7H0V4.3h8.4L5.04.96 6.01 0 11 5l-4.99 5Z" fill="currentColor"/></svg>
</template>
